import { render, staticRenderFns } from "./MailAttachments.vue?vue&type=template&id=f3db0de6&"
import script from "./MailAttachments.vue?vue&type=script&lang=js&"
export * from "./MailAttachments.vue?vue&type=script&lang=js&"
import style0 from "./MailAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports